/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { VesselInfoProps } from '../redux/types';
import { RootState } from '../../../redux/rootState';

function CommonTableWithTwoColumn({ data }:VesselInfoProps) {
  const { themePdfColor, reportPdfResponse3 } = useSelector((state:RootState) => state.reportPdfSliceReducer);
  const { BorderColor, MainColor } = themePdfColor;

  const offset = useMemo(() => {
    if (reportPdfResponse3?.Tube_Bundle_Layout) {
      const vessel = reportPdfResponse3?.Tube_Bundle_Layout?.flat()?.find(((v) => (v?.JobOrder === data?.JobOrder && v?.VesselId === String(data?.VesselId || ''))));
      if (vessel) {
        return vessel.Offset;
      }
      return '';
    }
    return '';
  }, [reportPdfResponse3]);

  return (
    <table className="bordered-table w100 mxWidth400 pb30 mb30 noTableBreak">
      <div
        className="tableAfterThickBorderStyle"
        style={{
          backgroundColor: BorderColor,
        }}
      />
      <div
        className="tableBeforeThickBorderStyle"
        style={{
          backgroundColor: BorderColor,
        }}
      />
      <tr>
        <td colSpan={2} className="tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>
          {data.VesselName}
        </td>
      </tr>
      <tr>
        <td className="textRight w45">TestEnd</td>
        <td className="textCenter w55">{data.TestEnd}</td>
      </tr>
      <tr>
        <td className="textRight w45">Tube Count</td>
        <td className="textCenter w55">{data.TubeCount}</td>
      </tr>
      <tr>
        <td className="textRight w45">Tube Type</td>
        <td className="textCenter w55">{data.TubeType}</td>
      </tr>
      <tr>
        <td className="textRight w45">Tube Material</td>
        <td className="textCenter w55">{data.Material}</td>
      </tr>
      <tr>
        <td className="textRight w45">OD</td>
        <td className="textCenter w55">
          {data?.OD !== undefined && data?.OD !== null
            ? (Number.isInteger(data.OD) ? Number(data.OD).toFixed(2) : data.OD)
            : '-'}
        </td>
      </tr>
      {data?.IsNwtOnly ? (
        <tr>
          <td className="textRight w45">*NWT</td>
          <td className="textCenter w55">{data.Nwt}</td>
        </tr>
      ) : (
        <>
          <tr>
            <td className="textRight w45">*NWT/Under Fins</td>
            <td className="textCenter w55">{data.NwtUnderFins}</td>
          </tr>
          <tr>
            <td className="textRight w45">*NWT/Bell/Land</td>
            <td className="textCenter w55">{data.NWTBell}</td>
          </tr>
        </>
      )}
      <tr>
        <td className="textRight w45">#/Type Support</td>
        <td className="textCenter w55">{data.TypeSupport}</td>
      </tr>
      <tr>
        <td className="textRight w45">Tube Numbering</td>
        <td className="textCenter w55">{offset?.length > 0 ? (offset === '1' ? 'Top to Bottom' : 'Left to Right') : data.TubeNumbering}</td>
      </tr>
      <tr>
        <td className="textRight w45">Row Numbering</td>
        <td className="textCenter w55">{offset?.length > 0 ? (offset === '1' ? 'Left to Right' : 'Top to Bottom') : data.RowNumbering}</td>
      </tr>
      <tr>
        <td className="textRight w45">Tube Length +- 2</td>
        <td className="textCenter w55">{`${data.TubeLength} inches`}</td>
      </tr>
    </table>
  );
}

export default CommonTableWithTwoColumn;
